import Box from '@mui/material/Box';
import Modal from '../../Modal/ModalBasic';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormControlLabel, Radio } from './styled';

export interface RescheduleReasonResult {
  reason: string;
  // adicione outros campos do formulário aqui
}

interface FormRescheduleReason {
  reason: string;
  reason_other: string;
}

interface ISelectAvailableTimes {
  open: boolean;
  onConfirm: (result: RescheduleReasonResult) => void;
  onCancel: () => void;
}

const RescheduleReason = ({ open, onConfirm, onCancel }: ISelectAvailableTimes) => {
  const {
    register,
    control,
    trigger,
    getValues,
    setValue,
    formState: { errors }
  } = useForm<FormRescheduleReason>();
  const methods = useForm<FormRescheduleReason>();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue('reason', event.target.value);
    setValue('reason_other', '');
    trigger('reason');
  };

  const onSubmit = (data: FormRescheduleReason) => {
    const payload = {
      reason: data.reason_other || data.reason
    };
    onConfirm(payload);
  };

  return (
    <Modal
      open={open}
      onCloseHandler={() => {
        onCancel();
      }}
      title="Porque você deseja reagendar?"
      typeTitle="h3"
    >
      <Box mb={1} mt={1}>
        <FormProvider {...methods}>
          <form onSubmit={(e: any) => e.preventDefault()}>
            <Controller
              name="reason"
              control={control}
              rules={{
                required: 'Campo obrigatório'
              }}
              render={({ field }) => (
                <FormControl error={!!errors?.reason} fullWidth>
                  <RadioGroup
                    {...field}
                    name="reason"
                    value={field.value || ''}
                    onChange={e => {
                      field.onChange(e);
                      handleChange(e);
                    }}
                  >
                    <FormControlLabel
                      value="Compromisso de trabalho inesperado"
                      control={<Radio />}
                      label={<Typography variant="body2R">Compromisso de trabalho inesperado</Typography>}
                    />
                    <FormControlLabel
                      value="Dificuldade de logística ou deslocamento"
                      control={<Radio />}
                      label={<Typography variant="body2R">Dificuldade de logística ou deslocamento</Typography>}
                    />
                    <FormControlLabel
                      value="Questões familiares"
                      control={<Radio />}
                      label={<Typography variant="body2R">Questões familiares</Typography>}
                    />
                    <FormControlLabel
                      value="Imprevisto de saúde"
                      control={<Radio />}
                      label={<Typography variant="body2R">Imprevisto de saúde</Typography>}
                    />
                    <FormControlLabel
                      value="Prefiro não informar"
                      control={<Radio />}
                      label={<Typography variant="body2R">Prefiro não informar</Typography>}
                    />
                    <FormControlLabel
                      value="outro"
                      control={<Radio />}
                      label={<Typography variant="body2R">Outro</Typography>}
                    />
                  </RadioGroup>
                </FormControl>
              )}
            />

            {getValues('reason') === 'outro' && (
              <Controller
                name="reason_other"
                control={control}
                rules={{
                  required: 'Campo obrigatório'
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    id="reason_other"
                    type="text"
                    variant="standard"
                    value={getValues('reason_other')}
                    error={!!errors?.reason_other}
                    helperText={errors?.reason_other?.message}
                    inputProps={{
                      classes: {
                        input: 'multilineColor'
                      }
                    }}
                    fullWidth
                    {...register('reason_other', {
                      required: 'Campo Obrigatório',
                      onChange: () => {
                        trigger('reason_other');
                      }
                    })}
                  />
                )}
              />
            )}

            {errors?.reason?.message && <FormHelperText error>{errors?.reason?.message}</FormHelperText>}
          </form>
        </FormProvider>
      </Box>
      <Box mb={1} mt={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          disabled={getValues('reason') === 'outro' ? !getValues('reason_other') : !getValues('reason')}
          onClick={() => {
            onSubmit(getValues());
          }}
          endIcon={<ArrowForwardIcon />}
        >
          Continuar
        </Button>
      </Box>
    </Modal>
  );
};

export default RescheduleReason;
